import snarkdown from 'snarkdown';
import insane from 'insane';

export const renderMarkdown = content =>
  insane(snarkdown(content), {
    allowedAttributes: {
      a: ['href', 'name', 'target'],
      img: ['src'],
    },
    allowedSchemes: ['http', 'https', 'mailto'],
    allowedTags: ['a', 'b', 'br', 'code', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'img', 'kbd', 'li', 'ol', 'strike', 'strong', 'sub', 'sup', 'u', 'ul'],
  });
